import { render } from "./NotesModal.vue?vue&type=template&id=071a1ce4&scoped=true"
import script from "./NotesModal.vue?vue&type=script&lang=js"
export * from "./NotesModal.vue?vue&type=script&lang=js"

import "./NotesModal.vue?vue&type=style&index=0&id=071a1ce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071a1ce4"]])

export default __exports__